<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search :loading="loading" :resourceSettings="resourceSettings" @searchResource="searchResource"
            @create="() => { newResource = {}; dialog = true; }" />
        </v-col>
        <!-- <v-col cols="12" CustomPageActions>
                      <v-card class="px-3" :loading="loading">
                        <v-row class="pa-0">
                          <v-col cols="6">
                            <v-btn block text color="success" :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-icon left>sync</v-icon>
                              Custom
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col> -->
        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete :items="countries" v-model="selectedCountry" :label="i18n.country"
                    autocomplete="disabled" outlined hide-details :disabled="!user.hq" dense clearable
                    @change="filterLeads()" item-value="id" :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span v-bind="attr" :input-value="selected" v-on="on" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <v-chip x-small>{{ i18n[item.slug] }}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ i18n[item.slug] }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete :items="programs" v-model="selectedProgram" :label="i18n.program"
                    autocomplete="disabled" outlined hide-details clearable dense @change="filterLeads()" item-value="id"
                    :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span v-bind="attr" :input-value="selected" v-on="on" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <v-chip x-small>{{ i18n[item.slug] }}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ i18n[item.slug] }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete :items="users" v-model="selectedUser" :label="i18n.employee" autocomplete="disabled"
                    outlined :filter="filterObject" hide-details clearable dense @change="filterLeads()" item-value="id"
                    :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <span v-bind="attr" :input-value="selected" v-on="on" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <v-chip x-small>{{ item.name }}</v-chip>
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ item.name }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete hide-details chips clearable multiple label="Profile" outlined small-chips dense
                    @change="filterLeads()" :items="profile_filter_items" v-model="profile_filter_value"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete hide-details chips clearable multiple label="Language" outlined small-chips dense
                    @change="filterLeads()" :items="language_filter_items"
                    v-model="language_filter_value"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete hide-details chips clearable multiple label="Visa" outlined small-chips dense
                    @change="filterLeads()" :items="visa_filter_items" v-model="visa_filter_value"></v-autocomplete>
                </v-col>

                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-menu v-model="menu7" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="createdAtFrom" label="Created from" prepend-icon="calendar_today" readonly
                        hide-details outlined @change="filterLeads()" dense clearable v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="createdAtFrom" @change="filterLeads()" @input="menu7 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-menu v-model="menu8" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="createdAtTo" label="Created to" prepend-icon="calendar_today" readonly
                        hide-details outlined @change="filterLeads()" dense clearable v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="createdAtTo" @change="filterLeads()" @input="menu8 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-menu v-model="menu9" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="updatedAtFrom" label="Updated from" prepend-icon="calendar_today" readonly
                        hide-details outlined @change="filterLeads()" dense clearable v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="updatedAtFrom" @change="filterLeads()" @input="menu9 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-menu v-model="menu10" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="updatedAtTo" label="Updated to" prepend-icon="calendar_today" readonly
                        hide-details outlined @change="filterLeads()" dense clearable v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="updatedAtTo" @change="filterLeads()" @input="menu10 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-menu v-model="menu11" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="registeredAtFrom" label="Registeration date from"
                        prepend-icon="calendar_today" readonly hide-details outlined @change="filterLeads()" dense
                        clearable v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="registeredAtFrom" @change="filterLeads()"
                      @input="menu11 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-menu v-model="menu12" :close-on-content-click="false" transition="scale-transition" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="registeredAtTo" label="Registeration date to" prepend-icon="calendar_today"
                        readonly hide-details outlined @change="filterLeads()" dense clearable v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="registeredAtTo" @change="filterLeads()"
                      @input="menu12 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Dates
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_called_before_date_from" label="Last Called Before Date From"
                              @update:modelValue="(value) => { last_called_before_date_from = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_called_before_date_to" label="Last Called Before Date To"
                              @update:modelValue="(value) => { last_called_before_date_to = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_updated_before_date_from" label="Last Updated Before Date From"
                              @update:modelValue="(value) => { last_updated_before_date_from = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_updated_before_date_to" label="Last Updated Before Date To"
                              @update:modelValue="(value) => { last_updated_before_date_to = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_evaluation_before_date_from"
                              label="Last Evaluation Before Date From"
                              @update:modelValue="(value) => { last_evaluation_before_date_from = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_evaluation_before_date_to" label="Last Evaluation Before Date To"
                              @update:modelValue="(value) => { last_evaluation_before_date_to = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_interview_before_date_from"
                              label="Last Interview Before Date From"
                              @update:modelValue="(value) => { last_interview_before_date_from = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_interview_before_date_to" label="Last Interview Before Date To"
                              @update:modelValue="(value) => { last_interview_before_date_to = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_note_before_date_from" label="Last Note Before Date From"
                              @update:modelValue="(value) => { last_note_before_date_from = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                          <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                            <DateField :modelValue="last_note_before_date_to" label="Last Note Before Date To"
                              @update:modelValue="(value) => { last_note_before_date_to = value; filterLeads() }"
                              icon="calendar_today" />
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
            @pageByNumber="pageByNumber" />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center mb-1">
                <candidateListPanel 
                  :resource="resource"
                  :resourceSettings="resourceSettings"
                  @editLead="editLead"
                  @getLogs="getLogs"
                  @copyS="clipboardSuccessHandler"
                  @copyF="clipboardErrorHandler"
                  @updateResource="updateResource"
                  @printCandidate="printCandidate"
                  @selectCandidateForDetails="(r) => (selectedDetailsCandidate = r)" :loading="loading"
                  @resendEmail="resendEmail"
                  :resourceKeys="resourceKeys" 
                />
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog :dialog="dialog" :loading="loading" :resourceSettings="resourceSettings" :deleting="deleting"
          :resourceKeys="resourceKeys" :newResource="newResource"
          @closeDialog="() => { dialog = false; newResource = {}; }" @deleteResource="deleteResource"
          @updateResource="updateResource" @postResource="postResource" />

        <candidatePrintDialog @closeDialog="print_dialog = false" :print_dialog="print_dialog"
          :printResource="printResource" />

        <CandidateDetailsDialog @copyS="clipboardSuccessHandler" :resource="selectedDetailsCandidate"
          @close="() => (selectedDetailsCandidate = null)" />

        <CandidateLog
          :r="logs"
          :dialog="logs_dialog"
          :resource_id="resource_log_id" 
          @close="() => (logs_dialog = false)"  
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import candidateListPanel from '@/components/candidateListPanel'
import candidatePrintDialog from '@/components/candidatePrintDialog.vue';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
import DateField from '../components/partials/DateField.vue';
import CandidateDetailsDialog from '../components/candidateDetailsDialog.vue';
import CandidateLog from '@/components/candidateLog.vue';
const headers = { 'Accept': 'application/json' };
let api_fire_base = 'https://us-central1-aramcco-crm.cloudfunctions.net/main'

export default {
  components: { Search, Paging, multiDialog, candidateListPanel, candidatePrintDialog, DateField, CandidateDetailsDialog, CandidateLog },
  data() {
    const i18n = this.$store.state.i18n[this.$store.state.language]
    const genders = [{ text: i18n.male, gender_id: 'male' }, { text: i18n.female, gender_id: 'female' }];

    return {
      logs: null,
      logs_dialog: false,
      resource_log_id: null,
      selectedDetailsCandidate: null,
      printResource: null,
      loading: false,
      print_dialog: false,
      dialog: false,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [
        { name: 'program_id', label: 'program', type: 'select', items: 'programs', data: [], source: 'db', required: true, readonly: true },
        { name: 'country_id', label: 'country', type: 'select', items: 'countries', source: 'db', data: [], required: true, readonly: false },
        { name: 'aramcco_code', label: 'aramcco_code', type: 'number', fetched: 'aramcco_code', required: false, readonly: true },
        { name: 'registration_date', label: 'registration_date', type: 'date', fetched: 'registration_date', required: true, readonly: false },
        { name: 'name', label: 'name', type: 'text', fetched: 'name', required: true, readonly: false },
        { name: 'email', label: 'email', type: 'text', fetched: 'email', required: true, readonly: false },
        { name: 'phone', label: 'phone', type: 'text', fetched: 'phone', required: true, readonly: false },
        { name: 'phone_alternative', label: 'phone_alternative', type: 'text', fetched: 'phone_alternative', required: true },
        { name: 'birth_date', label: 'birth_date', type: 'date', fetched: 'birth_date', required: true, readonly: false },
        { name: 'birth_place', label: 'birth_place', type: 'text', fetched: 'birth_place', required: true, readonly: false },
        { name: 'gender', label: 'gender', type: 'select', items: null, data: genders, source: null, required: true, readonly: false },
        { name: 'id_number', label: 'id_number', type: 'text', fetched: 'id_number', required: true, readonly: false },
        { name: 'last_pass_number', label: 'last_pass_number', type: 'text', fetched: 'last_pass_number', required: false },
        { name: 'access', label: 'access', type: 'switch', required: false },
        { name: 'application_suspended', label: 'application_suspended', type: 'switch', required: false },
        { name: 'language_access', label: 'language_access', type: 'switch', required: false },
        // { name: 'registration_contract_id', label:'registration_contract_id', type:'select', items:'contracts', data:[], source:'db',  required: true },
        { name: 'language_level_id', label: 'language_level_id', type: 'select', items: 'levels', data: [], source: 'db', required: true },
        { name: 'last_language_certificate_id', label: 'last_language_certificate_id', type: 'select', items: 'levels', data: [], source: 'db', required: true },
        { name: 'notes', label: 'notes', type: 'textarea', fetched: 'notes', required: false },
        { name: 'employee_id', label: 'employee_id', type: 'select', items: 'users', data: [], source: 'db', required: true },
      ],
      resourceSettings: {
        resourceName: null,
        search: true,
        create: true,
        pagination: true,
      },
      newResource: { aramcco_code: 'auto' },
      editing: false,
      deleting: false,
      interviews: [],
      templates: [],
      lists: [],
      types: [],
      units: [],
      generated_user: null,

      // Filters
      programs: [],
      countries: [],
      selectedCountry: null,
      selectedProgram: null,
      selectedUser: null,
      createdAtFrom: null,
      createdAtTo: null,
      updatedAtFrom: null,
      updatedAtTo: null,
      registeredAtFrom: null,
      registeredAtTo: null,

      // Dates
      last_called_before_date_from: null,
      last_called_before_date_to: null,

      last_updated_before_date_from: null,
      last_updated_before_date_to: null,

      last_evaluation_before_date_from: null,
      last_evaluation_before_date_to: null,

      last_interview_before_date_from: null,
      last_interview_before_date_to: null,

      last_note_before_date_from: null,
      last_note_before_date_to: null,

      profile_filter_items: [
        { text: 'Submitted cv', value: 'submitted_cv' },
        { text: 'Submited portrait', value: 'submited_portrait' }
      ],
      profile_filter_value: [],
      language_filter_items: [
        { text: 'Language started', value: 'language_started' },
        { text: 'A1 started', value: 'a1_started' },
        { text: 'A1 finished', value: 'a1_finished' },
        { text: 'A2 started', value: 'a2_started' },
        { text: 'A2 finished', value: 'a2_finished' },
        { text: 'B1 started', value: 'b1_started' },
        { text: 'B1 finished', value: 'b1_finished' },
        { text: 'B2 started', value: 'b2_started' },
        { text: 'B2 finished', value: 'b2_finished' },
        { text: 'B2 passed', value: 'b_2_passed' },
        { text: 'B2 certificate', value: 'b_2_certificate' },
        { text: 'B1 certificate submited', value: 'b_1_certificate_submited' },
        { text: 'B2 certificate submited', value: 'b_2_certificate_submited' },
      ],
      language_filter_value: [],
      visa_filter_items: [
        { text: 'Application suspended', value: 'application_suspended' },
        { text: 'Accelerated procedure documents ready', value: 'accelerated_procedure_documents_ready' },
        { text: 'Accelerated procedure submitted', value: 'accelerated_procedure_submitted' },
        { text: 'Accelerated procedure result', value: 'accelerated_procedure_result' },
        { text: 'Ba documents ready', value: 'ba_documents_ready' },
        { text: 'Ba submitted', value: 'ba_submitted' },
        { text: 'Ba result', value: 'ba_result' },
        { text: 'Visa application ready', value: 'visa_application_ready' },
        { text: 'Visa application submitted', value: 'visa_application_submitted' },
        { text: 'Visa granted', value: 'visa_granted' },
        { text: 'Booked airline ticket', value: 'booked_airline_ticket' },
      ],
      visa_filter_value: [],
      page: 1,
      menu7: false,
      menu8: false,
      menu9: false,
      menu10: false,
      menu11: false,
      menu12: false,
    }
  },

  methods: {
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ")
              c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
              return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    resendEmail(candidate){
      return new Promise(async (res, rej) => {
        if (!this.getCookie(`last-resent-at-${candidate.id}`)) {
          this.loading = true
          const expires_at = new Date((new Date()).getTime() + 60 * 60 * 1000);
          this.$store.dispatch('postResource', { resource: `/candidates/${candidate.id}/resend-email` }).then(() => {
            this.setCookie(`last-resent-at-${candidate.id}`, expires_at, expires_at)
            res(true)
            this.loading = false
          })
        }
        else {
          this.$emit('snackbarNotification', 'Please try again later', 'error')
        }
      })
    },
    printCandidate(r) {
      this.printResource = r
      this.print_dialog = true
    },
    getLogs(id) {
      return new Promise(async (res, rej) => {
        this.loading = true
        this.logs = await this.$store.dispatch('getResource', { resource: `/candidate/${id}/logs` })
        this.loading = false
        this.logs_dialog = true
        res(true)
      })
    },
    buildFilter() {
      let filter = ``

      if (this.selectedCountry) {
        filter += `&country=${this.selectedCountry}`
      }

      if (this.selectedProgram) {
        filter += `&program=${this.selectedProgram}`
      }

      if (this.selectedUser) {
        filter += `&employee=${this.selectedUser}`
      }

      if (this.createdAtFrom) {
        filter += `&created_at_from=${this.createdAtFrom}`
      }

      if (this.createdAtTo) {
        filter += `&created_at_to=${this.createdAtTo}`
      }

      if (this.updatedAtFrom) {
        filter += `&updated_at_from=${this.updatedAtFrom}`
      }

      if (this.updatedAtTo) {
        filter += `&updated_at_to=${this.updatedAtTo}`
      }

      if (this.registeredAtFrom) {
        filter += `&registered_at_from=${this.registeredAtFrom}`
      }

      if (this.registeredAtTo) {
        filter += `&registered_at_to=${this.registeredAtTo}`
      }

      if (this.last_called_before_date_from) {
        filter += `&last_call_from=${this.last_called_before_date_from}`
      }

      if (this.last_called_before_date_to) {
        filter += `&last_call_to=${this.last_called_before_date_to}`
      }

      if (this.last_updated_before_date_from) {
        filter += `&last_update_from=${this.last_updated_before_date_from}`
      }

      if (this.last_updated_before_date_to) {
        filter += `&last_update_to=${this.last_updated_before_date_to}`
      }

      if (this.last_evaluation_before_date_from) {
        filter += `&last_evaluation_from=${this.last_evaluation_before_date_from}`
      }

      if (this.last_evaluation_before_date_to) {
        filter += `&last_evaluation_to=${this.last_evaluation_before_date_to}`
      }

      if (this.last_interview_before_date_from) {
        filter += `&last_interview_from=${this.last_interview_before_date_from}`
      }

      if (this.last_interview_before_date_to) {
        filter += `&last_interview_to=${this.last_interview_before_date_to}`
      }

      if (this.last_note_before_date_from) {
        filter += `&last_note_from=${this.last_note_before_date_from}`
      }

      if (this.last_note_before_date_to) {
        filter += `&last_note_to=${this.last_note_before_date_to}`
      }

      if (this.profile_filter_value.length > 0) {
        this.profile_filter_value.forEach(item => {
          filter += `&${item}=true`
        })
      }

      if (this.language_filter_value.length > 0) {
        this.language_filter_value.forEach(item => {
          filter += `&langauge[${item}]=true`
        })
      }

      if (this.visa_filter_value.length > 0) {
        console.log('visa_filter_value', this.visa_filter_value.length)
        this.visa_filter_value.forEach(item => {
          filter += `&visa[${item}]=true`
        })
      }

      return filter
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x => typeof x == 'string')
      let a = false
      v.forEach(x => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if (itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async filterLeads() {
      await this.loadResource()
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    editLead(r) {
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    async loadItems() {
      return new Promise(async (res, rej) => {
        let iks = ['countries', 'programs'];

        for (let i = 0; i < iks.length; i++) {
          const f = iks[i];
          let t = this.resource[f]
          console.log(t)
          if (!t.error)
            t.forEach(x => this.$store.state.i18n.en[x.slug] = x.en)
          t.forEach(x => this.$store.state.i18n.ar[x.slug] = x.ar)
          t.forEach(x => this.$store.state.i18n.fr[x.slug] = x.fr)
          this[f] = t
        }

        if (this.user.countries.length == 1) {
          this.selectedCountry = this.user.countries[0].id
        }

        let ks = this.resourceKeys.filter(x => x.type == 'select' && x.source == 'db');
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x => {
              return {
                ...x,
                text: x.name ? x.name : x.en ? x.en : 'unknown',
                [`${f.name}_id`]: x.id
              }
            })
          }
          res(true)
        })()
      })
    },
    superA() {
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d) {
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
        !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x => { })
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${this.page}` + this.buildFilter(), })
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + '/search', value: this.search })
        }
        this.loading = false
        await this.loadItems()
        res(true)
      })
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true
        this.page = n
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${n}` + this.buildFilter() })
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + `/search?page=${n}`, value: this.search })
        }
        this.loading = false
        res(true)
      })
    },
    async searchResource(search) {
      return new Promise(async (res, rej) => {
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + '/search', value: this.search })
        this.loading = false
        res(true)
      })
    },
    async updateResource(r) {
      // By doing this i remove any object from the resource since we don't actually need objects to be sent to the PUT endpoint
      const updateResource = Object.keys(r).reduce((acc, key) => {
        if (typeof r[key] != 'object') {
          acc[key] = r[key]
        }
        return acc
      }, {})

      return new Promise(async (res, rej) => {
        this.loading = true
        console.log(r)
        this.$store.dispatch('putResource', { resource: this.$route.path + `/${r.id}`, value: updateResource }).then(async () => {
          this.dialog = false
          this.editing = false
          this.loading = false
          await this.loadResource()
          this.newResource = {}
          res(true)
        })
        .catch(() => {
          this.loading = false
          this.$emit('snackbarNotification', 'An error has occured !', 'error')
        })
      })
    },
    async deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        await this.$store.dispatch('deleteResource', { resource: this.$route.path + `/${r.id}` })
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async registerToFire(candidate) {
      return new Promise(async (res, rej) => {
        let user = {
          name: candidate.name,
          email: candidate.email,
          password: randomString(8, '#Aa')
        }
        let a = await axios.post(`${api_fire_base}/registerNewUser`, user, { headers: headers }).then(x => x.data)
          .catch(error => console.log(error))
        res({ ...user, ...a.user })
      })
    },
    async postResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        
        let user = await this.registerToFire(r)
        r.generated_password = user.password
        r.google_uid = user.uid
        console.log(user.uid)
        this.generated_user = user
        console.log(JSON.stringify(r))

        this.$store.dispatch('postResource', { resource: this.$route.path + `${r.id ? '/' + r.id : ''}`, value: r }).then(async () => {
          this.dialog = false
          this.loading = false
          await this.loadResource()
          this.newResource = {}
          this.print_dialog = true
          this.printResource = data.candidate
          res(true)
        })
        .catch((err) => {
          this.loading = false
          this.$emit('snackbarNotification', 'An error has occured !', 'error')
          rej(err)
        })
      })
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch: {
    '$store.state.online'(value) {
      this.loading = !Boolean(value)
    }
  },
  computed: {
    api() {
      return this.$store.state.settings.apiBase
    },
    users() {
      return this.resource.users
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x => {
        if (!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site() {
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin() {
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(x => x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == this.$route.path)
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles() {
      return this.$store.state.userRoles
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp)
    },
  },
  async created() {
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()
  },

}
</script>

<style>
.adminSwitch .v-input {
  margin-top: 0 !important;
}

.adminSwitch .v-input__control {
  margin-bottom: 0 !important;
}

.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>